import React, { useEffect, useState } from "react";
import "./VersioningComponent.css";

const VersioningComponent = ({ isOpen, onClose, version }) => {
  const [latestRelease, setLatestRelease] = useState(null);

  useEffect(() => {
    const loadReleaseNotes = async () => {
      try {
        const response = await fetch("/releaseNotes.txt");

        const text = await response.text();
        const data = JSON.parse(text);

        if (!data || !data.version || !data.date || !data.notes) {
          throw new Error("Invalid release notes format");
        }

        setLatestRelease(data);
      } catch (error) {
        console.error("Failed to load release notes:", error);
        setLatestRelease({ version: version || "N/A", date: "N/A", notes: [] });
      }
    };

    loadReleaseNotes();
  }, [version, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="version-modal-container">
      <div className="version-modal-container-content">
        <h2 className="version-modal-close" onClick={onClose}>
          ×
        </h2>
        <div className="version-modal-header">
          <h2 className="version-modal-title">Version Info</h2>
        </div>

        <div className="version-info-item">
          <span className="version-info-label">Version:</span>
          {version || latestRelease.version}
        </div>
        <div className="version-info-item">
          <span className="version-info-label">Release Date:</span>
          {latestRelease.date}
        </div>

        <div className="version-changes-title">Changes:</div>
        <ul className="version-changes-list">
          {latestRelease.notes.map((note, idx) => (
            <li key={idx} className="version-changes-item">
              {note}
            </li>
          ))}
        </ul>

        <div className="version-modal-footer">
          <button onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default VersioningComponent;
